<template>
  <div class="main" v-if="angebote">
    <div v-if="!nichtBeauftragte">
      <h1 style="margin-top:0px"> 
        <span class="pointer">Alle Angebote</span> |
        <span class="pointer grey" @click="nichtBeauftragte = true">Absagen</span>
      </h1>
      <div class="filters">
        <div>
          <input class="filter-input" type="text" placeholder="Suchen..." v-model="filter" />
        </div>
      </div>
      <table v-if="filter.length">
        <tbody v-if="angebote.length">
          <tr class="table-head">
            <th scope="row">Empfänger</th>
            <th scope="row">Bauvorhaben</th>
            <th scope="row">Adresse</th>
            <th scope="row">Angebotsdatum</th>
            <th scope="row">Absage</th>
            <th scope="row">Details</th>
          </tr>
          <tr v-for="a in filtered" v-bind:key="a.id">
            <td>{{ a.empfaenger }}</td>
            <td>{{ a.bvh }}</td>
            <td>{{ a.rechnungsadresse }}</td>
            <td>{{ a.angebotsdatum| dateOnly }}</td>
            <td><span v-if="a.nichtBeauftragt" class="material-icons">highlight_off</span></td>
            <td class="button-col">
              <router-link
                class="button arrow-button"
                :to="{ name: 'EditAngebot', params: { id: a.id }}">
                  <span class="material-icons">arrow_forward</span>
                </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <table v-else>
        <tbody v-if="angebote.length">
          <tr class="table-head">
            <th scope="row">Empfänger</th>
            <th scope="row">Bauvorhaben</th>
            <th scope="row">Adresse</th>
            <th scope="row">Angebotsdatum</th>
            <th scope="row">Absage</th>
            <th scope="row">Details</th>
          </tr>
          <tr v-for="a in angebote" v-bind:key="a.id">
            <td>{{ a.empfaenger }}</td>
            <td>{{ a.bvh }}</td>
            <td>{{ a.rechnungsadresse }}</td>
            <td>{{ a.angebotsdatum | dateOnly }}</td>
            <td><span v-if="a.nichtBeauftragt" class="material-icons">highlight_off</span></td>
            <td class="button-col">
              <router-link
                class="button arrow-button"
                :to="{ name: 'EditAngebot', params: { id: a.id }}">
                  <span class="material-icons">arrow_forward</span>
                </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="nichtBeauftragte">
      <h1 style="margin-top:0px"> 
        <span class="pointer grey" @click="nichtBeauftragte = false">Alle Angebote</span> |
        <span class="pointer">Absagen</span>
      </h1>
      <div class="filters">
        <div>
          <input class="filter-input" type="text" placeholder="Suchen..." v-model="filter" />
        </div>
      </div>
      <table v-if="filter.length">
        <tbody v-if="angebote.length">
          <tr class="table-head">
            <th scope="row">Empfänger</th>
            <th scope="row">Bauvorhaben</th>
            <th scope="row">Adresse</th>
            <th scope="row">Angebotsdatum</th>
            <th scope="row">Absage</th>
            <th scope="row">Details</th>
          </tr>
          <tr v-for="a in filteredNichtB" v-bind:key="a.id">
            <td>{{ a.empfaenger }}</td>
            <td>{{ a.bvh }}</td>
            <td>{{ a.rechnungsadresse }}</td>
            <td>{{ a.angebotsdatum| dateOnly }}</td>
            <td><span v-if="a.nichtBeauftragt" class="material-icons">highlight_off</span></td>
            <td class="button-col">
              <router-link
                class="button arrow-button"
                :to="{ name: 'EditAngebot', params: { id: a.id }}">
                  <span class="material-icons">arrow_forward</span>
                </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <table v-else>
        <tbody v-if="nichtB.length">
          <tr class="table-head">
            <th scope="row">Empfänger</th>
            <th scope="row">Bauvorhaben</th>
            <th scope="row">Adresse</th>
            <th scope="row">Angebotsdatum</th>
            <th scope="row">Absage</th>
            <th scope="row">Details</th>
          </tr>
          <tr v-for="a in nichtB" v-bind:key="a.id">
            <td>{{ a.empfaenger }}</td>
            <td>{{ a.bvh }}</td>
            <td>{{ a.rechnungsadresse }}</td>
            <td>{{ a.angebotsdatum | dateOnly }}</td>
            <td><span v-if="a.nichtBeauftragt" class="material-icons">highlight_off</span></td>
            <td class="button-col">
              <router-link
                class="button arrow-button"
                :to="{ name: 'EditAngebot', params: { id: a.id }}">
                  <span class="material-icons">arrow_forward</span>
                </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>

  <div v-else>Keine Angebote gefunden.</div>

</template>

<script>
const fb = require("../fbConfig.js");
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      filter: "",
      nichtBeauftragte: false
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "angebote"]),
    filteredNichtB: function() {
      let inp = this.filter.toLowerCase();
      return this.nichtB.filter(obj => {
        return Object.keys(obj).some(
          key =>
            typeof obj[key] === "string" && obj[key].toLowerCase().includes(inp)
        );
      });
    },
    filtered: function() {
      let inp = this.filter.toLowerCase();
      return this.angebote.filter(obj => {
        return Object.keys(obj).some(
          key =>
            typeof obj[key] === "string" && obj[key].toLowerCase().includes(inp)
        );
      });
    },
    nichtB() {
      return this.angebote.filter(el => {
        return el.nichtBeauftragt == true
      })
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    },
    dateOnly(val) {
      return moment(val).format("DD.MM.YYYY")
    }
  }
}
</script>

<style scoped>
.main {
  margin-top: 100px;
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tr {
  height: 40px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-col {
  text-align: center;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.first-btn {
  margin-right: 10px;
}

.filter-input {
  box-sizing: border-box;
  border: 1px solid #999;
  outline: none;
  padding: 5px;
  background: #eeeeee;
  border-radius: 20px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  width: 200px;
  padding-left: 10px;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}

.pointer {
  cursor: pointer;
}

.grey {
  color: grey;
}

</style>